import FieldPadel from "../assets/padelfield.webp";

function PadelSection() {
    return (
        <section
            aria-label="Padel section"
            className="relative bg-[#000] -space-y-[16vw]"
        >
            <div className="flex flex-col gap-28 z-10 relative h-full justify-top">
                <div className="flex flex-col z-20">
                    <h2 className="font-[900] text-light text-[7vw] text-center">PADEL</h2>
                    <h2 className="font-[900] text-yellow text-[7vw] text-center -mt-[7vw]">COSA CALCOLIAMO?</h2>
                    <p className="font-[900] text-light text-[3vw] text-center">
                        Zone di rimbalzo, prime e heatmap
                    </p>
                </div>
            </div>
            <div className="
                    w-full overflow-hidden group h-full pt-[8vw]
                    sm:pt-0
            ">
                <img
                src={FieldPadel}
                alt="Campo da padel"
                className="
                        object-cover scale-150 object-top w-full h-full -mt-[6vw] ml-[6vw]
                        sm:scale-100 sm:mt-0 sm:ml-0
                        "
            />
            </div>
        </section>
    );
}

export default PadelSection;
